import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IBiller } from "types/biller";
import { getBiller } from "selectors";
import { BillerActionsCreator } from "../../actions/billerActionsCreator";
import { getSubDomain } from "utilities/helper";

export interface IUseBiller {
  getBiller: () => IBiller;
  loadBiller: () => Promise<void>;
}

export default (): IUseBiller => {
  const dispatch = useDispatch();
  const biller = useSelector(getBiller);

  const loadBillerRequest = useCallback(
    (subDomain: string) => {
      const getBillerAction = BillerActionsCreator.getBiller;

      return new Promise((resolve, reject) =>
        dispatch(getBillerAction(subDomain, resolve, reject))
      );
    },
    [dispatch]
  );

  const loadBiller = useCallback(async () => {
    const subDomain = getSubDomain();
    try {
      await loadBillerRequest(subDomain);
    } catch (error) {
      console.log(error);
    }
  }, [loadBillerRequest]);

  return {
    loadBiller,
    getBiller: () => biller,
  };
};
